import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/check-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-01beeecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "book-confirmation-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-status-bar" }, null, -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "content-area"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    "aria-hidden": "true",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "예약이 완료되었습니다")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "book-confirmation-info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider top" }, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider bottom" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "day-seat-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider bottom" }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "fare-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider bottom" }, null, -1 /* HOISTED */))
const _hoisted_12 = { class: "notice" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "fail-content-wrapper"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "예약에 실패하였습니다", -1 /* HOISTED */))
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isFetchedBookResultInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          ($setup.successBoardingDates.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("section", _hoisted_5, [
                  _hoisted_6,
                  _createVNode($setup["BookConfirmationInfo"], {
                    lineInfo: $setup.bookResult?.lineInfo,
                    bookDeteTime: $setup.bookResult?.bookDateTime,
                    onOnClickBusStopLocation: $setup.onClickBusStopLocation
                  }, null, 8 /* PROPS */, ["lineInfo", "bookDeteTime"]),
                  _hoisted_7
                ]),
                _createElementVNode("section", _hoisted_8, [
                  ($setup.successBoardingDates.length > 1)
                    ? (_openBlock(), _createBlock($setup["MultipleBookDateSeats"], {
                        key: 0,
                        lineTurnUid: $setup.bookResult?.lineInfo.lineTurnUid ?? '',
                        isBookConfirmation: true,
                        isMonthlyBook: 
            $setup.bookResult?.bookIntervalCode === $setup.BookIntervalCode.MONTH
          ,
                        boardingDates: $setup.successBoardingDates || [],
                        seatAssignYn: !!$setup.bookResult?.lineInfo.seatAssignYn
                      }, null, 8 /* PROPS */, ["lineTurnUid", "isMonthlyBook", "boardingDates", "seatAssignYn"]))
                    : (_openBlock(), _createBlock($setup["SingleBookDateSeats"], {
                        key: 1,
                        lineTurnUid: $setup.bookResult?.lineInfo.lineTurnUid ?? '',
                        boardDate: $setup.successBoardingDates[0]?.boardDate ?? '',
                        seatNo: $setup.successBoardingDates[0]?.seatNo ?? '',
                        seatAssignYn: !!$setup.bookResult?.lineInfo.seatAssignYn,
                        allocUid: $setup.successBoardingDates[0]?.allocUid ?? '',
                        isMonthlyBook: 
            $setup.bookResult?.bookIntervalCode === $setup.BookIntervalCode.MONTH
          
                      }, null, 8 /* PROPS */, ["lineTurnUid", "boardDate", "seatNo", "seatAssignYn", "allocUid", "isMonthlyBook"])),
                  _hoisted_9
                ]),
                _createElementVNode("section", _hoisted_10, [
                  ($setup.bookResult?.bookAmount)
                    ? (_openBlock(), _createBlock($setup["BookConfirmationTotalAmount"], {
                        key: 0,
                        totalBookAmount: $setup.bookResult?.bookAmount,
                        numberOfBookDates: $setup.successBoardingDates.length,
                        oneTimeFare: $setup.successBoardingDates[0].bookAmount,
                        isMonthlyBook: 
            $setup.bookResult?.bookIntervalCode === $setup.BookIntervalCode.MONTH
          
                      }, null, 8 /* PROPS */, ["totalBookAmount", "numberOfBookDates", "oneTimeFare", "isMonthlyBook"]))
                    : _createCommentVNode("v-if", true),
                  _hoisted_11
                ]),
                _createElementVNode("section", _hoisted_12, [
                  (
            $setup.bookResult?.bookIntervalCode === $setup.BookIntervalCode.DAY &&
            $setup.bookResult?.bookCancelEndDateTime
          )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, " * 예약취소는 " + _toDisplayString($setup.bookResult?.bookCancelEndDateTime) + "까지 가능합니다. ", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode($setup["InlineSvg"], {
                  class: "warning-icon",
                  src: require('@/assets/icons/warning-circle.svg'),
                  "aria-hidden": "true",
                  alt: ""
                }, null, 8 /* PROPS */, ["src"]),
                _hoisted_15
              ])),
          _createVNode($setup["FooterButton"], {
            class: "btn-footer",
            title: "확인",
            onOnClickFooterButton: $setup.onClickConfirm
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["PageModal"], {
      shouldShow: $setup.shouldShowMap,
      onBackHandler: () => $setup.toggleShowMap(false)
    }, {
      default: _withCtx(() => [
        _createVNode($setup["MapOfBusStop"], {
          class: "map",
          targetBusStop: $setup.selectedBusStop,
          onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowMap(false)))
        }, null, 8 /* PROPS */, ["targetBusStop"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
    ($setup.shouldShowBookFailedModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 1,
          title: $setup.bookFaileModalTitle,
          okButtonTitle: "확인",
          onOnClickOkButton: $setup.hideBookFailedModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, [
                _createTextVNode(_toDisplayString($setup.bookFailedDates) + " 예약이 되지 않았습니다 ", 1 /* TEXT */),
                _hoisted_18,
                _createTextVNode(" 실패사유: " + _toDisplayString($setup.bookFailedReasons), 1 /* TEXT */)
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}